export const PAYMENT_LINK_REFERA_PROFILE = 'refera'
export const PAYMENT_LINK_ME_LIVREI_CONTRACT = 'i_got_rid'
